import { PostalCodeRegex, ZipcodeRegex } from "../constants/regex";
import Countries from "../constants/countries";

/**
 * Normalize input (trim spaces, uppercase)
 */
function normalizePostalCode(value) {
    return value?.toString().trim().toUpperCase() ?? "";
}

/**
 * Normalizes a Canadian postal code:
 * - Uppercases all letters
 * - Removes all spaces and hyphens
 * - Formats as "A1A 1A1" (adds a space after the third character)
 */
export function normalizeCanadianPostalCode(postalCode) {
    if (!postalCode) return "";

    let normalized = postalCode
        .toString()
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");

    if (normalized.length <= 3) return normalized;
    return `${normalized.slice(0, 3)} ${normalized.slice(3, 6)}`.trim();
}

/**
 * Validate Canadian postal code
 */
export function isValidCanadianPostalCode(postalCode) {
    if (!postalCode) return false;
    return PostalCodeRegex.test(normalizePostalCode(postalCode));
}

/**
 * Validate US ZIP code (5-digit or ZIP+4)
 */
export function isValidUsZipCode(zipcode) {
    if (!zipcode) return false;
    return ZipcodeRegex.test(normalizePostalCode(zipcode));
}

/**
 * Max allowed length by country enum
 */
export function maxPostalCodeLength(country = Countries.USA) {
    switch (country) {
        case Countries.Canada:
            return 7; // "K1A 0B1"
        case Countries.USA:
            return 5; // "55401"
        default:
            //throw new Error(`Unknown country code: ${country}`);
            return 5;
    }
}

/**
 * Validate postal or ZIP code depending on country enum
 */
export function isValidPostalZipCode(value, country = Countries.USA) {
    if (!value) return false;

    switch (country) {
        case Countries.Canada:
            return isValidCanadianPostalCode(value);
        case Countries.USA:
            return isValidUsZipCode(value);
        default:
            return isValidUsZipCode(value);
            //throw new Error(`Unknown country code: ${country}`);
    }
}
